import { render, staticRenderFns } from "./my-div-input.vue?vue&type=template&id=38fbad71"
import script from "./my-div-input.vue?vue&type=script&lang=js"
export * from "./my-div-input.vue?vue&type=script&lang=js"
import style0 from "./my-div-input.vue?vue&type=style&index=0&id=38fbad71&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports